// File: frontend/src/components/UiLanguageToggle.js
// Version: 1.0 (2026-09-28, Phase 9 — план 09-04)
// Description: переключатель языка интерфейса (EN | RU) в шапке. Рисуется ТОЛЬКО
// у арендатора, чей признак `features.ui_languages` несёт два языка и больше;
// у остальных (features пуст) возвращает null — шапка не меняется.

import React from 'react';
import { useUiLanguage } from '../context/UiLanguageContext';
import './UiLanguageToggle.css';

const UiLanguageToggle = () => {
    const { lang, setLang, languages, t } = useUiLanguage();
    if (!Array.isArray(languages) || languages.length < 2) return null;

    return (
        <div className="ui-lang-toggle" role="group" aria-label={t('lang.label')}>
            {languages.map((code, i) => {
                const active = code === lang;
                return (
                    <React.Fragment key={code}>
                        {i > 0 && <span className="ui-lang-toggle__sep" aria-hidden="true">|</span>}
                        <button
                            type="button"
                            className={'ui-lang-toggle__btn' + (active ? ' ui-lang-toggle__btn--active' : '')}
                            aria-pressed={active ? 'true' : 'false'}
                            onClick={() => setLang(code)}
                        >
                            {String(code).toUpperCase()}
                        </button>
                    </React.Fragment>
                );
            })}
        </div>
    );
};

export default UiLanguageToggle;
